<template>
  <div>
    <div class="login">{{ info }}</div>
  </div>
</template>

<script>
import global from "../utils/Global";

export default {
  data() {
    return {
      info: null,
    };
  },
  mounted() {
    var qid = global.getCookie("main_header_account");
    if (!global.qid) {
      global
        .axios(this, global.ajaxAdd.checkUser, {
          account_qid: global.userInfo.qid,
        })
        .then((res) => {
          global.accountList = res.data;
          this.$router.push("ai");
        })
        .catch((e) => {
          if (e.data.errno == 700004 || e.data.errno == 700003) {
            global.userInfo = null;
            global.qid = null;
            this.$router.push("login");
            return;
          }
        });
    } else {
      this.setInfo(qid || global.qid);
    }
  },
  methods: {
    setInfo(qid) {
      var user_data = null;
      for (var i = 0; i < global.accountList.length; i++) {
        if (global.accountList[i].qid == qid) {
          user_data = global.accountList[i];
          break;
        }
      }
      if (!user_data) {
        user_data = global.accountList[0];
      }
      global.qid = user_data.qid;
      this.info = "";
      for (var key in user_data) {
        this.info += key + "：" + user_data[key] + "；";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/page/guide.vue